import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'
import { getProjectConfig } from 'features/projects/api'
import { projectKeys } from 'features/projects/api/queryKeys'
import { useContent } from 'features/unifiedFlow/contentPage/hooks'

const useIsBrazeContent = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const { content } = useContent()

  const projectId =
    content?.elements[0]?.optimization_settings?.configuration?.project_id

  const { data: projectConfig, isPending } = useQuery({
    queryKey: projectKeys.projectConfig({
      accountId,
      projectId: projectId ?? '',
    }),
    queryFn: () =>
      getProjectConfig(accountId, projectId!).then((res) => res.data.project),
    enabled: !!projectId,
    refetchOnWindowFocus: false,
  })

  return {
    isBrazeContent: projectConfig?.mappedUIFields?.integrationType === 'braze',
    isLoading: !!projectId && isPending,
  }
}

export default useIsBrazeContent
